import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  Page,
  Toolbar,
  Tabs,
  Tab,
  Icon,
  Link,
  Fab,
  f7,
  Block,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Calendar } from "@fullcalendar/core";
import listPlugin from "@fullcalendar/list";
const eatBidsLogo = require("./../images/logo/eatbids-logo.png");
const TabBid = () => {
  // const events = [
  //   { title: 'today',
  //     start: new Date() }
  // ]
  const [datapending, setPendingData] = useState([]);
  const [data, setData] = useState([]);
  const [confirmData, setConfirmData] = useState([]);
  const calendarElRef = useRef(null);
  useEffect(() => {
    axios
      .get(API_BASE_URL + "eventbyrest/id/" + localStorage.getItem("id"), {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          order_status: 1,
          limit: 100,
        },
      })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => console.log(error));
  }, []);
  useEffect(() => {
    axios
      .get(API_BASE_URL + "eventbyrest/id/" + localStorage.getItem("id"), {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          order_status: 2,
          limits: 100,
        },
      })
      .then((response) => {
        setPendingData(response.data.data);
      })
      .catch((error) => console.log(error));
    axios
      .get(API_BASE_URL + "restacceptorder", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
          limits: 100,
        },
      })
      .then((response) => {
        setConfirmData(response.data);
      })
      .catch((error) => console.log(error));
  }, []);
  function formatDateToYMD(c_date) {
    const date = new Date(c_date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    var current_date = `${year}-${month}-${day}`;
    return current_date;
  }
  useEffect(() => {
    if (confirmData.length > 0) {
      const calendar = new Calendar(calendarElRef.current, {
        plugins: [dayGridPlugin, listPlugin, interactionPlugin],
        timeZone: "UTC",
        events: confirmData.map((item, index) => ({
          title: item.event_name,
          start: item.event_date,
          extendedProps: {
            eventId: item.order_id,
            location: item.add_lin_1,
            created_by: item.created_by_text,
            payment_status: item.payment_status,
          },
        })),
        dayMaxEvents: true,
        eventClick: function (info) {
          f7.views.main.router.navigate(
            "/orderview/" + info.event.extendedProps.eventId
          );
        },
        initialView: "listMonth",
        height: "auto",
        headerToolbar: {
          right: "prev,next",
          left: "title",
        },
        dateClick: function (info) {
          f7.views.main.router.navigate("/confirmbid/" + info.dateStr);
        },
        eventContent: function (info) {
          return {
            html: `<div class="fc-event-main"><i>${info.timeText}</i> ${
              info.event.title
            } <br/> ${
              info.event.extendedProps.location
            }<br/><span class="text-1 text-success">By ${
              info.event.extendedProps.created_by
            }</span>, <span class="text-1 ${
              info.event.extendedProps.payment_status === "Paid"
                ? "text-success"
                : "text-danger"
            }">${info.event.extendedProps.payment_status}</span>`,
          };
        },
      });
      // Render the calendar
      calendar.render();
    }
  }, [confirmData]);

  const loadCalender = () => {
    if (confirmData.length > 0) {
      const calendar = new Calendar(calendarElRef.current, {
        plugins: [dayGridPlugin, listPlugin, interactionPlugin],
        timeZone: "UTC",
        events: confirmData.map((item, index) => ({
          title: item.event_name,
          start: item.event_date,
          extendedProps: {
            eventId: item.order_id,
            location: item.add_lin_1,
            created_by: item.created_by_text,
            payment_status: item.payment_status,
          },
        })),
        eventClick: function (info) {
          f7.views.main.router.navigate(
            "/orderview/" + info.event.extendedProps.eventId
          );
        },
        initialView: "listMonth",
        height: "auto",
        headerToolbar: {
          right: "prev,next",
          left: "title",
        },
        dateClick: function (info) {
          f7.views.main.router.navigate("/confirmbid/" + info.dateStr);
        },
        eventContent: function (info) {
          return {
            html: `<div class="fc-event-main"><i>${info.timeText}</i> ${
              info.event.title
            } <br/> ${
              info.event.extendedProps.location
            }<br/><span class="text-1 text-success">By ${
              info.event.extendedProps.created_by
            }</span>, <span class="text-1 ${
              info.event.extendedProps.payment_status === "Paid"
                ? "text-success"
                : "text-danger"
            }">${info.event.extendedProps.payment_status}</span></div>`,
          };
        },
      });
      calendar.render();
    }
  };
  const handleTabChange = () => {
    loadCalender();
  };

  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, // Replace with the actual path to your image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover", // Adjust as needed (e.g., 'contain', '100% 100%', etc.)
    backgroundPosition: "top left", // Positions the image at the top-left corner
    marginTop: "-30px",
    marginBottom: "-20px",
    marginLeft: "10px",
    width: "106px", // Set the width and height to fill the viewport
    height: "40px",
  };

  return (
    <Page className="bg-white">
      <Fab position="right-bottom" slot="fixed" href="/addevent/">
        <Icon ios="material:add" aurora="material:add" md="material:add"></Icon>
      </Fab>
      <div className="container container-table ">
        <div className="row vertical-center-row col-sm col-md-offset-12">
          <header className="section-t-space p-3">
            <div className="container-lg custom-container p-0">
              <div className="header-panel p-0">
                <h2 className="mt-0">Event</h2>
                <Link href="#" className="mt-0"></Link>
                <Link href="/ordersearch/" className="mt-0">
                  <Icon
                    ios="material:search"
                    aurora="material:search"
                    md="material:search"
                    className="theme-dark"
                    size={22}
                  ></Icon>
                </Link>
              </div>
              <div className="custom-logo d-none d-md-block" style={divStyle} />
            </div>
          </header>
          <div className="extraHeader p-0 bg-light d-flex justify-content-center">
            <Toolbar tabbar top className="bg-light" noShadow>
              <Link tabLink="#bid-1" tabLinkActive>
                REQUEST
              </Link>
              <Link tabLink="#bid-2">PENDING</Link>
              <Link tabLink="#bid-3">CONFIRMED</Link>
            </Toolbar>
          </div>
          <Tabs style={{ padding: "96px 12px" }}>
            <Tab id="bid-1" tabActive>
              <section className="section-t-space bg-white mt-0">
                <div className="container p-0">
                  <div className="row gy-3">
                    {data.length > 0 ? (
                      data.map((item) => (
                        <div className="bid-web-view-div">
                          <div className="custom-container p-0">
                            <a href={`/eventdetail/${item.id}/1`}>
                              <div className="vertical-product-box order-box">
                                <div className="vertical-box-img">
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/events.jpg")}
                                    alt="vp1"
                                  />
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5 className="dark-text">
                                        {item.event_name}
                                      </h5>
                                      <h5
                                        className={
                                          item.order_status == 5
                                            ? "text-danger"
                                            : "text-success"
                                        }
                                      >
                                        {item.order_status_text}
                                      </h5>
                                    </div>
                                    {item.delivery_type == "Delivery" ? (
                                      <h6 className="food-items mb-2">
                                        <Icon
                                          ios="material:location_on"
                                          aurora="material:location_on"
                                          md="material:location_on"
                                          className="text-success text-3"
                                        />{" "}
                                        {item.add_lin_1} {item.add_lin_2}{" "}
                                        {item.city} {item.state} {item.zip_code}
                                      </h6>
                                    ) : (
                                      <h6 className="food-items mb-2"></h6>
                                    )}
                                  </div>
                                  <div className="reorder">
                                    <h6 className="rating-star">
                                      <ul className="timing">
                                        <li>
                                          <Icon
                                            ios="material:groups"
                                            aurora="material:groups"
                                            md="material:groups"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_adult_size +
                                            item.event_kids_size}{" "}
                                        </li>
                                        <li>
                                          <Icon
                                            ios="material:event"
                                            aurora="material:event"
                                            md="material:event"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_date}
                                        </li>
                                        {/* <li className="text-success"> {item.order_status}</li> */}
                                      </ul>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="custom-container">
                        <div className="empty-tab">
                          <h2>No Current Event Found!!</h2>
                          <h5 className="mt-3">
                            You have currently no events.
                          </h5>
                          <a
                            href="/addevent/"
                            className="btn btn-success w-100 mt-5"
                            role="button"
                          >
                            Order for an Event
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </Tab>

            <Tab id="bid-2">
              <section className="section-t-space bg-white mt-0">
                <div className="container p-0">
                  <div className="row gy-3">
                    {datapending.length > 0 ? (
                      datapending.map((item) => (
                        <div className="bid-web-view-div">
                          <div className="custom-container p-0">
                            <a href={`/eventdetail/${item.id}/2`}>
                              <div className="vertical-product-box order-box">
                                <div className="vertical-box-img">
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/events.jpg")}
                                    alt="vp1"
                                  />
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5 className="dark-text">
                                        {item.event_name}
                                      </h5>
                                      <h5 className="text-success">
                                        {item.status_of_event}
                                      </h5>
                                    </div>
                                    {item.delivery_type == "Delivery" ? (
                                      <h6 className="food-items mb-2">
                                        <Icon
                                          ios="material:location_on"
                                          aurora="material:location_on"
                                          md="material:location_on"
                                          className="text-success text-3"
                                        />{" "}
                                        {item.add_lin_1} {item.add_lin_2}{" "}
                                        {item.city} {item.state} {item.zip_code}
                                      </h6>
                                    ) : (
                                      <h6 className="food-items mb-2"></h6>
                                    )}
                                  </div>
                                  <div className="reorder">
                                    <h6 className="rating-star">
                                      <ul className="timing">
                                        <li>
                                          <Icon
                                            ios="material:groups"
                                            aurora="material:groups"
                                            md="material:groups"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_adult_size +
                                            item.event_kids_size}{" "}
                                        </li>
                                        <li>
                                          <Icon
                                            ios="material:event"
                                            aurora="material:event"
                                            md="material:event"
                                            className="text-muted text-4"
                                          />{" "}
                                          {item.event_date}
                                        </li>
                                        {/* <li className="text-success"> {item.order_status}</li> */}
                                      </ul>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      ))
                    ) : (
                      <Block>
                        <div className="custom-container">
                          <div className="empty-tab">
                            <h2>No Event Request Found!!</h2>
                            <h5 className="mt-3">
                              You have currently no events requests.
                            </h5>
                          </div>
                        </div>
                      </Block>
                    )}
                  </div>
                </div>
              </section>
            </Tab>
            <Tab id="bid-3" onTabShow={handleTabChange}>
              <section className="section-t-space bg-white mt-0">
                <div className="container p-0">
                  <div className="row gy-3 bg-white">
                    {confirmData.length > 0 ? (
                      <section className="section-t-space bg-white mt-0">
                        {/* <FullCalendar
                        ref={calendarElRef}
                        plugins={[dayGridPlugin, interactionPlugin ]}
                        initialView='dayGridMonth'
                        weekends={true}
                        dateClick={handleDateClick}
                        events={events}
                        eventContent={renderEventContent}
                        headerToolbar={headerToolbarOptions}
                        contentHeight="auto"
                        deepChangeDetection="true"
                      /> */}
                        <div
                          className="color-theme-orange"
                          ref={calendarElRef}
                        ></div>
                      </section>
                    ) : (
                      <Block>
                        <div className="custom-container">
                          <div className="empty-tab">
                            <h2>No Confirm Bid Found!!</h2>
                            <h5 className="mt-3">
                              You have currently no confirm events.
                            </h5>
                          </div>
                        </div>
                      </Block>
                    )}
                  </div>
                </div>
              </section>
            </Tab>
          </Tabs>
        </div>
      </div>
    </Page>
  );
};

export default TabBid;
